var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssociationPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13L13 8.09432C13 7.80359 12.8735 7.52725 12.6534 7.33729L8 3.32096L3.34662 7.33727C3.12653 7.52723 3 7.80357 3 8.0943L3 13L13 13ZM15 8.09432L15 13C15 14.1046 14.1046 15 13 15L3 15C1.89543 15 1 14.1046 1 13L1 8.0943C1 7.2221 1.37958 6.39309 2.03985 5.82322L7.34661 1.24297C7.72197 0.919008 8.27803 0.919008 8.65339 1.24298L13.9602 5.82325C14.6204 6.39312 15 7.22213 15 8.09432Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13L9 10L7 10L7 13L9 13ZM11 10L11 13C11 14.1046 10.1046 15 9 15L7 15C5.89543 15 5 14.1046 5 13L5 10C5 8.89543 5.89543 8 7.00001 8L9.00001 8.00001C10.1046 8.00001 11 8.89544 11 10Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociationPage);
export default __webpack_public_path__ + "static/media/association-page.0f9ae39e.svg";
export { ForwardRef as ReactComponent };